export default "__VITE_ASSET__C3X258Hp__"